module.exports = __webpack_public_path__ + "img/euSmall.0c218510.png";